<template>
    <li class="sinSaltoDeLinea">
        <ul v-if="submenu.SubmenusQueMePertenecen.length <= 0" >
            <a v-if="submenu.EsDescarga == true && submenu.SeMuestraEnVisor == false" v-on:click="AbrirDocumento(submenu.RutaParaAccesar, '_blank');" class="nav-link" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenu.Titulo}}</a>
            <a v-else-if="submenu.EsDescarga == true && submenu.SeMuestraEnVisor == true" v-on:click="AbreElVisor(submenu.RutaParaAccesar);" class="nav-link" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenu.Titulo}}</a>
            <a v-else-if="submenu.RutaParaAccesar != null && submenu.RutaParaAccesar.includes('http')" class="nav-link" v-on:click="AbrirPaginaExterior(submenu.RutaParaAccesar);" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenu.Titulo}}</a>
            <router-link v-else-if="submenu.RutaParaAccesar != null" class="nav-link" :to="submenu.RutaParaAccesar" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenu.Titulo}}</router-link>
        </ul>
        <a v-else class="nav-link dropdown-item dropdown-toggle"  v-on:click="submenu.Mostrar = !submenu.Mostrar;" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }">{{submenu.Titulo}}</a>
        <ul v-if="submenu.SubmenusQueMePertenecen.length > 0 && submenu.Mostrar == true"  class="expandirSubmenu ">
            <SubmenusQueMePertenecen v-for="submenuQueMePertenece in submenu.SubmenusQueMePertenecen" v-bind:key="submenuQueMePertenece.SubmenuId" :submenu="submenuQueMePertenece"></SubmenusQueMePertenecen>
        </ul>
    </li>
</template>

<script>
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import comun from "@/../static/js/comun";

export default {
    name: "submenu",
    props: {
        submenu: Object
    }, 
    components: {
      SubmenusQueMePertenecen: () => import('./Submenus.vue')
    }, 
    methods: {
  AbrirPaginaExterior: function(vinculo){
  window.open(vinculo,'_blank')
  },
        AbrirDocumento: function(vinculo, formaDeApertura) {
           // console.log("vinculoooo:::",vinculo)
            //console.log("submenu:::",vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta));
            //window.open(vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos), formaDeApertura);
            //console.log(vinculo);
           comun.DescargarDocumentoPDF(vinculo);
        },
        AbreElVisor: function(vinculo) {
            // console.log("SUBMENUS::::::",this.submenu)
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
        }
    }
}
</script>

<style scoped>
    .sinSaltoDeLinea {
        white-space: nowrap; 
        width: 100%;
    }

    .enNegritas {
        font-weight: bold;
    }

    .nav-link {
        cursor: pointer;
    }

    .expandirSubmenu {
        display: inline-block; 
        width: 100%;
        padding-left: 8px;
        background-color: rgb(126,127,116);
    }

    a {
        font-size: 1rem;

    }

        a i {
            font-size: 7px;
            padding-right: 10px;
        }

    li {
        background-color: rgb(34,34,34);
        color: #FFF;
        padding: 0;
    }

        li a {
            background-color: rgb(34,34,34);
            color: #FFF !important;
            padding: 0.5rem 1.5rem !important;
            font-size: 1rem;
            
        }

            li a:hover {
                color: #212529;
                /* background-color: #FFF; */
            }

        li ul {
            list-style: none;
            padding: 0;
        }

          li ul a {
            /*background-color: rgb(34,34,34);*/
            background-color: rgb(0,117,115) !important;
            color: #FFF !important;
            padding: 0.5rem 1.5rem !important;
            font-size: 1rem;
          }

            li ul a:hover {
              /*color: #212529 !important;
                    background-color: #FFF;*/
              /* color: white !important; */
              background-color:  rgb(126,127,116) !important;
            }

            .activo-menu {
              /*color: #212529 !important;
                    background-color: #FFF;*/
              /* color: white !important; */
              background-color:  rgb(126,127,116) !important;
            }


          
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/MenuResponsivo/Submenus.vue